module.exports = __webpack_public_path__ + "img/live-music-1.d52aa963.jpg";